import cn from 'classnames';
import React from 'react';
import styles from './Icon.module.css';
import icons from './icons';

export type IconName = keyof typeof icons;

type IconProps = {
	name: IconName;
	className?: string;
	circular?: boolean;
};

export function Icon({name, className, circular}: IconProps) {
	const Icon = icons[name];

	if (!Icon) return null;

	return (
		<div className={cn(styles.root, className, {[styles.circular]: circular})}>
			<Icon className={styles.icon} />
		</div>
	);
}
